import { useState } from "react";
import { LineChart, Facebook, Twitter, Instagram, Linkedin, Send } from "lucide-react";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");

  const subscribe = (e) => {
    e.preventDefault();
    if (!email.includes("@")) return toast.error("Please enter a valid email.");
    toast.success("Subscribed! Watch your inbox for market insights.");
    setEmail("");
  };

  return (
    <footer className="relative border-t border-white/10 bg-[#020617] pt-20 pb-10 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-700 flex items-center justify-center">
                <LineChart className="w-5 h-5" strokeWidth={2.5} />
              </div>
              <div>
                <div className="font-black text-lg tracking-tight">Wealthoo</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-blue-400 font-bold">Fintech Pvt. Ltd.</div>
              </div>
            </div>
            <p className="text-sm text-slate-400 max-w-md">
              India&apos;s trusted fintech-first mutual fund distributor — empowering investors and advisors with
              technology, research and round-the-clock support.
            </p>

            <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-md" data-testid="newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Get weekly market insights"
                className="flex-1 bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm focus:border-blue-500 focus:outline-none"
                data-testid="newsletter-email"
              />
              <button className="btn-primary text-sm flex items-center gap-1.5" data-testid="newsletter-submit">
                <Send className="w-4 h-4" />
              </button>
            </form>

            <div className="flex gap-3 mt-6">
              {[Facebook, Twitter, Instagram, Linkedin].map((I, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 rounded-xl glass flex items-center justify-center hover:bg-blue-600/20 hover:border-blue-500/40 transition-colors"
                  data-testid={`social-${i}`}
                >
                  <I className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <FooterCol title="Company" links={["About Us", "Services", "Insights", "Careers", "Contact"]} />
            <FooterCol title="Investments" links={["Mutual Funds", "SIP", "ELSS / Tax Saving", "Retirement", "Wealth Mgmt"]} />
            <FooterCol title="Legal" links={["Privacy Policy", "Terms & Conditions", "Disclaimer", "Risk Disclosure", "Grievance"]} />
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-slate-500">
          <div>© 2026 Wealthoo Fintech Pvt. Ltd. All rights reserved. ARN-162408</div>
          <div className="max-w-2xl text-right">
            Mutual fund investments are subject to market risks. Read all scheme-related documents carefully. Past
            returns are not a guarantee of future returns.
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-blue-400 mb-4">{title}</h4>
      <ul className="space-y-2.5">
        {links.map((l) => (
          <li key={l}>
            <a href="#" className="text-sm text-slate-400 hover:text-white transition-colors">{l}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
